import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getQiwaContractData } from "../../../../../store/Api";
import { setAppError, setBreadCrumb } from "../../../../../store/userSlice";
import FileUploadElement from "../../../../../ReusableComponents/UploadFile/uplaodFile";
import ListQiwaContract from "./ListQiwaContract";

export default function QiwaContractTab(props) {
  const Client = useSelector((state) => state.qiwaData);
  const dispatch = useDispatch();

  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const token = localStorage.getItem("nodeToken");

  useEffect(() => {
    dispatch(getQiwaContractData(token));
  }, []);

  const updateData = () => {
    dispatch(getQiwaContractData(token));
  };

  return (
    <>
      <div className={`p-2  sm:p-5 `}>
        <ListQiwaContract
          list={Client}
          loading={loading}
          titles={[
            "S.NO.",
            "EMPLOYEE ID",
            "EMPLOYEE Name",
            "RELIGION",
            "NATIONALITY",
            "CURRENT SPONSOR",
            "CLIENT",
            "UPLOAD INSTANCE",
            "STATUS",
            "ACTION",
          ]}
          token={token}
          updateData={updateData}
        />
      </div>
    </>
  );
}
